<v-form
  (valueChange)="formValueChange($event)"
  *ngIf="{
    disabled: disabled$ | async,
    prefill: mappedPrefill$ ? (mappedPrefill$ | async) : null
  } as obs"
>
  <v-input
    name="configurationTitle"
    [title]="'configurationTitle' | pluginTranslate: pluginId | async"
    [margin]="true"
    [disabled]="obs.disabled"
    [defaultValue]="obs.prefill?.configurationTitle"
    [required]="true"
    [tooltip]="'configurationTitleTooltip' | pluginTranslate: pluginId | async"
    placeholder="DestructionProcedure Plugin"
  >
  </v-input>
  <v-input
    name="headInformationManagerUsername"
    [title]="'headInformationManagerUsername' | pluginTranslate: pluginId | async"
    [margin]="true"
    [defaultValue]="obs.prefill?.headInformationManagerUsername"
    [disabled]="obs.disabled"
    [required]="true"
  >
  </v-input>
  <v-input
    name="archivalEmail"
    [title]="'archivalEmail' | pluginTranslate: pluginId | async"
    [margin]="true"
    [defaultValue]="obs.prefill?.archivalEmail"
    [disabled]="obs.disabled"
    [required]="true"
  >
  </v-input>
  <v-multi-input-form
    name="destructionProcedureProperties"
    [title]="'departments' | pluginTranslate: pluginId | async"
    [formTemplate]="mappingForm"
    [addRowText]="'addDestructionProcedureType' | pluginTranslate: pluginId | async"
    [required]="false"
    [tooltip]="'departmentsTooltip' | pluginTranslate: pluginId | async"
    (deleteRowEvent)="deleteRow($event)"
    [initialAmountOfRows]="0"
    [minimumAmountOfRows]="0"
    [defaultValues]="obs.prefill?.destructionProcedureProperties"
  >
  </v-multi-input-form>
</v-form>

<ng-template #mappingForm let-index="index" let-uuid="uuid" let-changeFunction="changeFunction" let-prefill="prefill">
  <ng-container
    *ngIf="{
      disabled: disabled$ | async
    } as obs"
  >
    <v-form (valueChange)="changeFunction($event, uuid); destructionProcedureTypeFormChange($event, uuid)">
      <v-input
        name="departmentName"
        [title]="'departmentName' | pluginTranslate: pluginId | async"
        [margin]="false"
        [disabled]="obs.disabled"
        [defaultValue]="prefill?.departmentName"
        [required]="true"
        [tooltip]="'departmentNameTooltip' | pluginTranslate: pluginId | async"
        [smallMargin]="true"
        placeholder=""
      >
      </v-input>
      <v-input
        name="departmentHeadUsername"
        [title]="'departmentHeadUsername' | pluginTranslate: pluginId | async"
        [margin]="false"
        [disabled]="obs.disabled"
        [defaultValue]="prefill?.departmentHeadUsername"
        [required]="true"
        [tooltip]="'departmentHeadUsernameTooltip' | pluginTranslate: pluginId | async"
        [smallMargin]="true"
        placeholder=""
      >
      </v-input>
      <!-- <v-input class="hidden-input" name="uuid" [defaultValue]="uuid"> </v-input> -->
    </v-form>
  </ng-container>
</ng-template>
